import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Formats number so that it contains spaces.
 *
 * Ex.: 100000 -> 100 000
 *      12345.45423 -> 12 345.45423
 */
export function numberWithSpaces(x) {
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.');
}

/**
 * "/home/user/docs/file.txt"  -> "file.txt"
 * "C:\\Users\\User\\file.txt"  -> "file.txt"
 * "file.txt" -> "file.txt"
 */
export function getFileNameFromPath(path) {
  if (!path) return '';

  const parts = path.split(/[/\\]/);

  return parts.pop();
}
